import React, { FC } from 'react';

import * as analytics from '@adsk/acs-web-analytics';
import { PageNotFound } from '@adsk/alloy-error-page';
import { LinkButton } from '@adsk/alloy-react-button';

import { ANALYTICS_TYPES } from '../../analytics';
import i18n from '../../utils/i18n';

const analyticReportAndNavigate = () => {
  analytics.track(ANALYTICS_TYPES.EXO_NAVIGATE_RESULT_404_GO_HOME);
};

const PageNotFoundExo: FC = () => {
  return (
    <PageNotFound
      title={i18n.t('CAN_NOT_OPEN_LINK')}
      description={i18n.t('CAN_NOT_OPEN_LINK_DESCRIPTION')}
      action={
        <LinkButton as="a" href="/" onClick={analyticReportAndNavigate}>
          {i18n.t('GO_TO_PROJECT_LIST')}
        </LinkButton>
      }
    />
  );
};

export default PageNotFoundExo;
